var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUsersLog = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50452 8.86176C10.9038 8.86176 12.8488 6.87798 12.8488 4.43088C12.8488 1.98377 10.9038 0 8.50452 0C6.10525 0 4.16027 1.98377 4.16027 4.43088C4.16027 6.87798 6.10525 8.86176 8.50452 8.86176Z",
    fill: "#8D939C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9895 16.4624C16.9201 15.0227 16.4414 13.6306 15.6075 12.4433C14.7737 11.256 13.6178 10.3207 12.2703 9.74296C12.0917 9.69935 11.9051 9.69673 11.7253 9.73532C11.5454 9.77391 11.3771 9.85266 11.2334 9.96543C10.4731 10.5838 9.5151 10.9205 8.52709 10.9164C7.53907 10.9122 6.58403 10.5677 5.82919 9.94294C5.68688 9.8279 5.51931 9.74672 5.33963 9.70573C5.15995 9.66475 4.97303 9.66508 4.7935 9.70671C3.43999 10.2714 2.27477 11.1961 1.42971 12.3761C0.584648 13.5561 0.0934738 14.9443 0.0117675 16.3836C-0.101749 17.4248 0.455626 19.9621 8.48853 19.9996C16.5214 20.0371 17.0967 17.5048 16.9895 16.4624Z",
    fill: "#8D939C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUsersLog);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_users_log.a6441f0a005640a3f79b55b7d51cce3b.svg";